import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

import type {
  TDropdownMenuRadioGroupProps,
} from "@/ui/components/overlay/DropdownMenu/DropdownMenu.config";

export const DropdownMenuRadioGroup = (props: TDropdownMenuRadioGroupProps) => (
  <DropdownMenuPrimitive.RadioGroup
    data-component="DropdownMenuRadioGroup"
    {...props}
  />
);

DropdownMenuRadioGroup.displayName = DropdownMenuPrimitive.RadioGroup.displayName;
